import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};
export const firebaseApp = initializeApp(firebaseConfig);

export const messaging = (async () => {
  try {
    const isSupportedBrowser = await isSupported();
    // console.log("isSuported browser-->", isSupportedBrowser);
    if (isSupportedBrowser) {
      return getMessaging(firebaseApp);
    } else {
      console.log("Firebase is not supported in this browser");
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
})();

export const messagingResolve = await messaging;
